import React, { useRef, useState } from "react";
import { FiUser } from "react-icons/fi";
import { AccountModalBody, AccountModalFooter, AccountModalHeader } from "./AccountModalParts";
import { UpdateGender} from "./Account.api";
import { useAuth } from "context/auth-context";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { toastrError, toastrSuccess } from "lib/toastr";
import { useTranslation } from "react-i18next";

interface AccountToggleProps {
  gender: string;
  isPopupOpenGender;
}
const GenderToggle: React.FC<AccountToggleProps> = ({ gender, isPopupOpenGender }) => {
  const { auth } = useAuth();
  const { t } = useTranslation();
  const modelRef = useRef();
  const [userGender, setUserGender] = useState(gender);
  const queryClient = useQueryClient();
  const mutation = useMutation(() => UpdateGender(userGender,auth?.panelistId), {
    onSuccess: (response: any) => {
      if (response.success) {
        toastrSuccess(t("genderTogel.success"));
        queryClient.invalidateQueries(["getAccountDetailsapi"]);
      } else {
        toastrError(t("genderTogel.failed"));

      }
    },
    onError: () => {
      toastrError(t("genderTogel.terminate"));
    },
  });

  const handleSubmit = () => {
    mutation.mutate();
    isPopupOpenGender();
  };

  const CloseModal = (e) => {
    if (modelRef.current === e.target) {
      isPopupOpenGender();
    }
  };

return (
  <>
    {isPopupOpenGender && (
      <div
        className="zs-backdrop"
        ref={modelRef}
        onClick={CloseModal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="account-gender-title"
      >
        <div className="zs-modal max-w-md">
          <AccountModalHeader
            titleId="account-gender-title"
            title={t("genderTogel.head")}
            icon={<FiUser />}
            onClose={isPopupOpenGender}
          />

          <AccountModalBody>
            <div>
              <label className="zs-label">{t("genderTogel.lebel.select")}</label>
              <select onChange={(e) => setUserGender(e.target.value)} className="zs-select">
                <option value="" disabled selected hidden>
                  {t("genderTogel.option.select")}
                </option>
                <option value="male">{t("genderTogel.option.male")}</option>
                <option value="female">{t("genderTogel.option.female")}</option>
                <option value="other">{t("genderTogel.option.other")}</option>
              </select>
            </div>
          </AccountModalBody>
          <AccountModalFooter>
            <button className="zs-btn zs-btn-primary" onClick={handleSubmit}>
              {t("genderTogel.button")}
            </button>
          </AccountModalFooter>
        </div>
      </div>
    )}
  </>
);

};

export default GenderToggle;
